/** H7 greybox start town C (ท่าระฆังเงียบ, origin C): see townGrey.ts. */
import { townLayout, townZone } from './townGrey';

export const TOWN_C_LAYOUT = townLayout('town-c', 702);
export const TOWN_C_ZONE = townZone('town-c', 'ท่าระฆังเงียบ', 702, [0.98, 1.02, 1.04]);
